import { LoadingSpinner } from "@shared/components/LoadingSpinner";
import { getProfileThumbnail } from "@shared/hooks/useProfile";
import theme from "@shared/utils/themeColors";
import { useTopTesters } from "../hooks/useTopTesters";

function TopTesters() {
  const { loading, error, topTesters } = useTopTesters();

  if (loading) {
    return (
      <div
        className={`col-span-full xl:col-span-12 ${theme.bg.primary} shadow-sm rounded-xl p-4`}
      >
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div
        className={`col-span-full xl:col-span-12 ${theme.bg.primary} shadow-sm rounded-xl p-4`}
      >
        <p className={`${theme.text.error} dark:text-red-400`}>{error}</p>
      </div>
    );
  }

  return (
    <div
      className={`col-span-full xl:col-span-12 ${theme.bg.primary} shadow-sm rounded-xl`}
    >
      <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60">
        <h2 className={`font-semibold ${theme.text.primary}`}>Top Testers</h2>
      </header>
      <div className="p-3">
        {/* Table */}
        <div className="overflow-x-auto">
          <table className="table-auto w-full dark:text-gray-300">
            {/* Table header */}
            <thead
              className={`text-xs uppercase ${theme.text.inactive} bg-gray-50 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm`}
            >
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-left">Name</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-center">
                    Tests Completed
                  </div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-center">
                    Correct Answers
                  </div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-center">
                    Incorrect Answers
                  </div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-center">Total Score</div>
                </th>
              </tr>
            </thead>
            {/* Table body */}
            <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
              {topTesters.map((tester) => (
                <tr key={tester.userId}>
                  <td className="p-2">
                    <div className="flex items-center">
                      <img
                        src={getProfileThumbnail(tester)}
                        alt={tester.name}
                        className="w-8 h-8 rounded-full mr-2 sm:mr-3"
                      />
                      <div className={theme.text.primary}>{tester.name}</div>
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="text-center">{tester.testsCompleted}</div>
                  </td>
                  <td className="p-2">
                    <div className={`text-center ${theme.text.success}`}>
                      {tester.correctAnswers}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className={`text-center ${theme.text.error}`}>
                      {tester.incorrectAnswers}
                    </div>
                  </td>
                  <td className="p-2">
                    <div className="text-center text-sky-500">
                      {tester.totalScore?.toFixed(1)}%
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default TopTesters;
